import { DestroyRef, Directive, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatOption, MatSelect } from '@angular/material/select';

@Directive({
  selector: 'mat-option[slcSelectAll]',
  standalone: true,
})
export class SliceOptionSelectAllDirective {
  private select = inject(MatSelect);
  private option = inject(MatOption);
  private destroyRef = inject(DestroyRef);

  ngAfterViewInit(): void {
    const control = this.select.ngControl.control;
    if (!control) {
      return;
    }

    this.option.onSelectionChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (ev) => {
          if (ev.isUserInput) {
            if (ev.source.selected) {
              control.setValue(this.allValues());
              this.option.select(false);
            } else {
              control.setValue([]);
              this.option.deselect(false);
            }
          }
        },
      });

    this.select.optionSelectionChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (ev) => {
          if (ev.source !== this.option) {
            if (!ev.source.selected) {
              this.option.deselect(false);
            } else {
              if (control.value.length === this.allValues().length) {
                this.option.select(false);
              }
            }
          }
        },
      });
  }

  private allValues() {
    return this.select.options
      .filter((_, index) => index > 0)
      .map((opt) => opt.value);
  }
}
